type VisibilityTarget = Pick<Document, "visibilityState" | "addEventListener" | "removeEventListener">

function browserDocument(): VisibilityTarget | undefined {
  return typeof document === "undefined" ? undefined : document
}

export function pageIsVisible(target: Pick<VisibilityTarget, "visibilityState"> | undefined = browserDocument()) {
  return !target || target.visibilityState === "visible"
}

export function jitterDelay(baseMs: number, maxJitterMs = Math.min(1000, baseMs), random = Math.random) {
  const base = Math.max(0, baseMs)
  const jitter = Math.max(0, maxJitterMs)
  if (jitter === 0) return base
  return base + Math.floor(random() * jitter)
}
